import React from 'react';
import { useParams, Link } from 'react-router-dom';

function QueryPage() {
  const { query } = useParams();

  return (
    <div className="App">
      <header className="App-header">
        <h1>Query Page</h1>
        <p>
          You are viewing the query parameter: <strong>{query}</strong>
        </p>
        <p>
          This page handles any route that matches the pattern <code>/:query</code>
        </p>
        <div style={{ marginTop: '20px' }}>
          <Link to="/" style={{ 
            color: '#61dafb', 
            textDecoration: 'none', 
            padding: '10px 20px', 
            border: '1px solid #61dafb', 
            borderRadius: '5px'
          }}>
            Back to Home
          </Link>
        </div>
        <div style={{ marginTop: '10px' }}>
          <p>Try these example routes:</p>
          <Link to="/hello-world" style={{ 
            color: '#61dafb', 
            textDecoration: 'none', 
            padding: '5px 10px', 
            border: '1px solid #61dafb', 
            borderRadius: '3px',
            marginRight: '10px',
            fontSize: '14px'
          }}>
            /hello-world
          </Link>
          <Link to="/user/123" style={{ 
            color: '#61dafb', 
            textDecoration: 'none', 
            padding: '5px 10px', 
            border: '1px solid #61dafb', 
            borderRadius: '3px',
            marginRight: '10px',
            fontSize: '14px'
          }}>
            /user/123
          </Link>
          <Link to="/custom-query" style={{ 
            color: '#61dafb', 
            textDecoration: 'none', 
            padding: '5px 10px', 
            border: '1px solid #61dafb', 
            borderRadius: '3px',
            fontSize: '14px'
          }}>
            /custom-query
          </Link>
        </div>
      </header>
    </div>
  );
}

export default QueryPage; 